import { render } from "./StageNavMobile.vue?vue&type=template&id=128a7970&scoped=true&ts=true&lang=pug"
import script from "./StageNavMobile.vue?vue&type=script&lang=ts&setup=true"
export * from "./StageNavMobile.vue?vue&type=script&lang=ts&setup=true"

import "./StageNavMobile.vue?vue&type=style&index=0&id=128a7970&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128a7970"]])

export default __exports__